export const MOVE_TO_NEW_BUTTON = 'move_to_new_button';
export const MOVE_TO_TRASH_BUTTON = 'move_to_trash_button';
export const MOVE_TO_LEGAL_BUTTON = 'move_to_legal_button';
export const ACTION_BUTTON = 'action_button';

